export default `---
slug: slovenia
country: Slovenia
countryCode: SVN
continent: Europe
year: 2019
title: "Slovenia"
description: "Lake Bled, the Julian Alps, and a country that punches way above its weight."
thumbnail: /images/travels/SVN/slovenia_thumb.jpg
relatedLinks: []
---
![slovenia](/images/travels/SVN/slovenia_thumb.jpg)

*Story coming soon — stay tuned!*

I visited Slovenia and it was an incredible experience. Full story and photos are being written up and will appear here soon.
`;
